// extracted by mini-css-extract-plugin
export default {"ownerList":"adjust-owners-modal__ownerList--duWla"};